import type { ReactNode } from 'react';

import { DocumentSection } from '../DocumentSection';
import { Badge } from '@/shared/components/ui/badge';
import { messages } from '@/shared/constants/messages';

interface FormSectionProps {
  /** Vira a âncora do índice lateral (`#data-e-local`). */
  id: string;
  number: number;
  title: string;
  description?: string;
  optional?: boolean;
  children: ReactNode;
}

/**
 * Uma das cinco seções do formulário (spec-project-form.md §7.1) — casca fina
 * sobre `DocumentSection`, acrescentando só o que é de quem ESCREVE: o número
 * da seção e o crachá "opcional".
 *
 * A gramática (divisória, subtítulo, ausência de `Card`) e o porquê dela moram
 * no componente de baixo, que a tela de leitura também usa. Se esta casca
 * engrossar, a tela de detalhe começa a divergir do formulário de novo — foi
 * exatamente o que a decisão 18 desfez.
 */
export function FormSection({
  id,
  number,
  title,
  description,
  optional,
  children,
}: FormSectionProps) {
  return (
    <DocumentSection
      id={id}
      title={title}
      description={description}
      titleLeading={
        <span
          aria-hidden="true"
          className="flex size-6 items-center justify-center rounded-full bg-muted text-xs font-semibold text-muted-foreground"
        >
          {number}
        </span>
      }
      titleTrailing={optional ? <Badge variant="muted">{messages.form.optional}</Badge> : null}
    >
      <div className="space-y-5">{children}</div>
    </DocumentSection>
  );
}
